export type Priority = 'High' | 'Low';

interface PriorityColors {
  backgroundColor: string | undefined;
  color: string | undefined;
}

/**
 * Get the display label for a claim priority
 */
export const getPriorityLabel = (
  priority?: Priority,
  topClaimsCount?: number,
): string | null => {
  if (topClaimsCount) return `Top ${topClaimsCount}`;
  if (!priority) return null;
  return priority === 'High' ? 'Essential' : 'Optional';
};

/**
 * Get the colors for a claim priority badge
 */
export const getPriorityColor = (
  priority?: Priority,
  topClaimsCount?: number,
): PriorityColors => {
  if (topClaimsCount) {
    return {
      backgroundColor: 'var(--brand-colors-amber-500, #f59e0b)',
      color: 'var(--text-white, #ffffff)',
    };
  }
  if (!priority) return { backgroundColor: undefined, color: undefined };
  return priority === 'High'
    ? {
        backgroundColor: 'var(--error-dark, #b60000)',
        color: 'var(--text-white, #ffffff)',
      }
    : {
        backgroundColor: 'var(--brand-colors-neutral-500, #c8c8cf)',
        color: 'var(--text-primary, #141413)',
      };
};
